import clsx from 'clsx';

import { TestimonialFieldsFragment } from 'api/graphql-types';
import { sanitizeAndParseHtml } from 'utils/rich-text-renderer/sanitize-and-parse';
import { Typography } from 'components/typography';
import Image from 'components/image';

import styles from './testimonial.module.scss';

export interface ITestimonialProps {
	module: TestimonialFieldsFragment;
}

export const Testimonial = ({ module }: ITestimonialProps): React.JSX.Element => {
	const { quoteTitle, quote, name, organization, photo, logo, defaultModuleOptions } = module;
	const twoColStyles = photo && photo.data?.attributes?.url && styles.twoCol;
	const lightStyles = defaultModuleOptions?.extendedBackgroundColor === 'darkblue' && styles.light;

	return (
		<div className={clsx(styles.testimonial, twoColStyles, lightStyles)}>
			<div className={styles.photo}>
				{photo && photo.data?.attributes?.url && (
					<Image
						attributes={photo.data?.attributes}
						imageSize="small"
						style={{ objectFit: 'cover' }}
						width={270}
						height={270}
					/>
				)}
			</div>

			<div className={styles.body}>
				<div className={styles.content}>
					{quoteTitle?.value && (
						<Typography tag={quoteTitle?.type || 'h2'} variant="h3">
							{quoteTitle.value}
						</Typography>
					)}
					{quote && <div>{sanitizeAndParseHtml(quote)}</div>}
				</div>

				<div className={styles.author}>
					<Typography tag="div" variant="h5">
						{name}
					</Typography>
					{organization && <p>{organization}</p>}
				</div>

				<div className={styles.logo}>
					{logo && logo.data?.attributes?.url && (
						<Image
							attributes={logo?.data?.attributes}
							fallbackAlt={organization}
							imageSize="thumbnail"
							width={166}
							height={72}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default Testimonial;
